<div *ngIf='componentReady' class='AddBlockDateRule'>
  <mat-horizontal-stepper [formGroup]='inputForm'>
    <mat-step>
      <ng-template matStepLabel>Blocked Emails</ng-template>
      <ng-template matStepContent>
        <app-select [items]='block_types' [multi]='true' formControlName='block_type'
                    label='Select block types...'></app-select>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Timezones</ng-template>
      <ng-template matStepContent>
        <app-select [items]='timezones' [multi]='true' formControlName='timezones'
                    label='Select timezones...'></app-select>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>States</ng-template>
      <ng-template matStepContent>
        <app-select [items]='states' [multi]='true' formControlName='states' label='Select state...'></app-select>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Managers</ng-template>
      <ng-template matStepContent>
        <app-select [items]='managersItems' [multi]='true' formControlName='managers'
                    label='Select managers...'></app-select>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Partners</ng-template>
      <ng-template matStepContent>
        <app-select [items]='partnersItems' [multi]='true' formControlName='partners'
                    label='Select partners...'></app-select>
      </ng-template>
    </mat-step>
  </mat-horizontal-stepper>
</div>